import {useState, useEffect} from "react";
import {ReactComponent as Fold} from "assets/image/Layout/PropertyPanel/ic_dropdown_fold.svg";
import {ReactComponent as Unfold} from "assets/image/Layout/PropertyPanel/ic_dropdown_unfold.svg";
import {ReactComponent as Check} from "assets/image/Common/ic_check_white.svg";
import styles from "./index.module.scss";
import SelectDropDown from "components/Common/Dropdown/SelectDropDown";

const DropDownInput = ({name, array = [], dropdownOnChange, value, selectedObject, dropdownOpened, setDropdownOpened, depth}) => {
  let currentValue = value || array[0];
  if (name === "ToneMappingMode" || name === "Blending") {
    currentValue = array[value || 0];
  }
  const [currentSelected, setCurrentSelected] = useState(currentValue);

  useEffect(() => {
    let currentValue = value || array[0];
    if (name === "ToneMappingMode" || name === "Blending") {
      currentValue = array[value || 0];
    }
    setCurrentSelected(currentValue);
  }, [selectedObject]);

  let title = "";
  if (name === "FogMode" || name === "ToneMappingMode") {
    title = "Mode";
  } else if (name === "HSVBlendMode" || name === "BloomBlendMode" || name === "BCBlendMode") {
    title = "Blend Mode";
  } else if (name === "FontWeight") {
    title = "Weight";
  } else {
    title = name;
  }
  let widerDropdown = false;
  if (
    name === "FogMode" ||
    name === "ToneMappingMode" ||
    name === "BloomBlendMode" ||
    name === "HSVBlendMode" ||
    name === "BCBlendMode" ||
    name === "Blending" ||
    name === "Preset" ||
    name === "Font" ||
    name === "FontWeight"
  ) {
    widerDropdown = true;
  }

  return (
    <div className={`${styles.container} ${depth === 1 ? styles.depth_1 : ""}`}>
      <p className={styles.title}>{title}</p>
      <div className={styles.wrapper}>
        <div
          className={`${styles.dropdown}
              ${dropdownOpened === name ? styles.dropdown_on : "off"}`}
          onClick={e => {
            e.stopPropagation();
            setDropdownOpened(dropdownOpened === name ? null : name);
          }}
        >
          <p>{currentSelected}</p>
          {dropdownOpened === name ? <Unfold /> : <Fold />}
        </div>
        {dropdownOpened === name && (
          <SelectDropDown
            style={{
              minWidth: "127px",
              maxHeight: "217px",
              overflow: "auto",
              justifyContent: "space-between",
              top: "4px",
            }}
          >
            {array.map((position, i) => (
              <div
                key={i}
                onClick={e => {
                  e.stopPropagation();
                  setCurrentSelected(position);
                  setDropdownOpened(null);
                  dropdownOnChange(name, position);
                }}
                className={`${position === currentSelected ? styles.active : ""} ${styles.item}`}
              >
                <Check className={position === currentSelected ? "" : styles.uncheck} />
                {position}
              </div>
            ))}
          </SelectDropDown>
        )}
      </div>
    </div>
  );
};

export default DropDownInput;
